<template lang="pug">
section#v-topics.container
  h2 What's the Future
  ol.timeline
    li(
      v-for='(year, index) of years',
      @click='selectYear(year, index)',
      :class='{active: year === years[pointer], disabled: !year}',
      :style='timelineOffset'
    ): label {{ year }}
  .tip(v-if='$store.state.mobile') swipe
  .topics
    button(v-if='!$store.state.mobile', @click='moveLeft'): img(src='@/assets/arrow-left-icon.png', width='20')
    ol
      li(:style='topicOffset'): ul
        li: span 全球 180 萬個職位將被 AI 取代
        li: span AI 將創造 230 萬個工作機會
        li: span 全球行動寬頻用戶達到 58 億
        li: span 「永續」是廠商採購原物料的重要參考因素
        li: span 全球金屬回收產值達 400 億美金
        li: span 印度完成巨大光纖網路，讓 6 億鄉村人口連網
        li: span 太陽能板每瓦特發電成本降至 1.2 美金
        li: span 全球電動車數量達 660 萬台
        li: span 日本用 ARM 處理器建造超級電腦 ExaFlop
        li: span 中國展開探索月球陰暗面計畫
      li(:style='topicOffset'): ul
        li: span AI 結合人腦工作的商業價值達到 2.9 兆美元
        li: span 5G 設備製造材料石英元件出現供應缺口
        li: span 全球永續性產品市場價值達 140 到 220 億美金，市占率達 25%
        li: span 全球電子回收產值達 145 億美金
        li: span 無線供電普及，電線開始走入歷史
        li: span 以太坊發行量減少 10 倍
        li: span 美國出現首位機器人藥劑師
        li: span 超過 80％ 的網路流量來自影片
        li: span 中國開始大規模生產自駕車
        li: span 市場推出翻譯耳塞，能即時翻譯
      li(:style='topicOffset'): ul
        li: span 75% 的政府與民間組織將更廣泛運用深度學習，來解決問題
        li: span 中國境內的 5G 基地台達 300 萬座
        li: span 由於環保稅等成本，天然氣成本上漲 10%
        li: span 煤礦成本翻倍成長，連帶減緩金屬回收產值的成長
        li: span 汽車開始導入撞擊防治煞車系統
        li: span 3D 列印汽車開始量產
        li: span 全球 10% 的人口將會透過衣服連網
        li: span 第一輛 3D 列印車將投入生產
        li: span 歐洲太空總署和 NASA 將試圖將小行星轉移出軌道
        li: span 美國展開清潔能源計畫
      li(:style='topicOffset'): ul
        li: span 年底全球 5G 行動用戶將超過十億
        li: span 英國人造肉食品銷售額成長 44% 達到 11 億英鎊
        li: span 塑膠包裝的回收比例達 14%
        li: span 智慧城市全球市場成長到 7172 億，年成長率 18.2%
        li: span 全球 10% 的眼鏡將會連網
        li: span 人口普查系統將交由大數據處理
        li: span 下一個摩爾定律會發生在「太陽能」產業，成本下降，效率提升
        li: span 美國開始推行降低國際貿易碳排的計畫
        li: span 地球上 80% 的人將會有網路上的數位身分
        li: span 將有政府使用大數據取代現有的審查機制
      li(:style='topicOffset'): ul
        li: span AI 醫療應用市場規模將達 110 億美元
        li: span AI 於醫療影像的應用價值將達 25 億美元
        li: span 全球 5G 覆蓋率將涵蓋全球 40% 的人口
        li: span 5G 增強型行動寬頻用戶數達 15 億，成為電信技術發展至今部署速度最快的世代
        li: span 全球回收產值達 3406 億美元
        li: span 太陽能成本降至每瓦特 0.95 美元
        li: span 全球電動車數量達到 921 萬
        li: span 50% 的網路流量來自於家電設備與家庭服務
        li: span 人造肌肉廣泛用於機器人，產生比人類肌肉更強的力量
        li: span 義肢將可以提供患者觸覺
      li(:style='topicOffset'): ul
        li: span 穿戴式 AI 市場價值達 1,800 億美元
        li: span 中國 5G 服務占全球傳輸量的 40%
        li: span 全球 20% 以上行動數據流量由 5G 網路產生
        li: span 全球企業大量採用可回收的「循環包裝」，部分企業（可口可樂、聯合利華）以 100% 採用率為目標
        li: span 全球紙資源回收產值達 549 億美元
        li: span 挪威禁止銷售燃油汽車
        li: span 電子設備能透過 WiFi 充電
        li: span 全球農業開始廣泛採用無人機協助耕作
        li: span 製造業 AI 市場規模達 160 億美元
        li: span 10 輛賣出的汽車中，有 1 輛是自駕車
      li(:style='topicOffset'): ul
        li: span 歐盟首次啟動實驗性國際熱核實驗反應堆（ITER）計畫
        li: span 全球電動車銷量達 10,526,667 輛
        li: span 全球網路流量達 452 Exabyte
        li: span 近紅外護目鏡讓外科醫生能觀察小至 1mm 的癌細胞、腫瘤
        li: span 水產養殖業成為全球大部分的海鮮供應來源
        li: span 大型粒子物理學設施國際直線對撞機建置成功
        li: span 人類成功合成首個人類基因組
        li: span 3D 列印薄膜開始用於預防心臟病發作
        li: span 阿茲海默症新療法出現
        li: span 馬爾地夫因海平面上升，當地居民大規模撤離
      li(:style='topicOffset'): ul
        li: span 輕型氫燃料電池汽車年銷量達 100 萬輛
        li: span 為緩解氣候變遷，全球部分國家執行碳截存計畫
        li: span 俄羅斯太空探測器 Venera-D 任務抵達金星
        li: span 小行星 1999 AN10 近距離接近地球，被科學家認為有潛在危險
        li: span 全球 10％ GDP 將使用區塊鏈技術進行儲存、交易
        li: span 微型機器人可以清除海洋中的二氧化碳
        li: span 4D 列印技術讓 3D 列印物品製造、使用彈性增加
        li: span 機器人服務普遍出現於大多數中產階級家庭
        li: span 太陽能電池成本降至每瓦特 0.7 美元
        li: span 金磚四國經濟地位超越 G7 國家
      li(:style='topicOffset'): ul
        li: span NASA 的深空門戶計畫完成，月球軌道空間站成為國際太空站繼任者
        li: span 龐大、重型的電子設備能像紙張一樣折疊、存放或攜帶
        li: span 英國報紙完全數位化
        li: span 數種已滅絕的動物被科學家復活
        li: span 人類史上第九個載人太空站「國際太空站」退役
        li: span 科學家成功操縱光合作用，使作物產量提高 1％
        li: span 帶有攝影功能的隱形眼鏡出現
        li: span 無人車對汽車保險公司的利潤開始產生影響
        li: span 通過基因工程，人類預期壽命大幅成長
        li: span 亞洲成為航空旅行的世界中心
      li(:style='topicOffset'): ul
        li: span 機器人智商程度接近人腦，可以與人類進行有意義的聊天
        li: span 4G 技術退出市場
        li: span 智慧語音技術市場達 155 億美元
        li: span 可移除二氧化碳的微型機器人將被「大量投放」至海洋
        li: span 太陽能道路與智慧窗戶的產值達 150 億美金
        li: span 第一隻「永生鼠」誕生
        li: span 電動車銷量達 1251 萬
        li: span 機器人性伴侶變得司空見慣
        li: span 人們可靠植入晶片，增強智力、記憶
        li: span 醫學讓皺紋不再存在
      li(:style='topicOffset'): ul
        li: span 全球將有 20% 的工作被機器人和自動化所取代
        li: span AI 產值達到 13 兆美元
        li: span 環境友善塑膠（生物可分解塑膠）普及化
        li: span 德國全面禁售燃油車
        li: span 飛行汽車進入商用階段
        li: span 3D 列印技術將普及於建造房屋
        li: span 太陽能發電成本降至每瓦特 0.5 美金
        li: span 全球聯網裝置高達 109 兆個
        li: span 6G 行動通訊技術廣泛使用，主宰 2030 年的世界
        li: span 新的迷你冰河時代將在 2030 年至 2036 年之間開始
    button(v-if='!$store.state.mobile', @click='moveRight'): img(src='@/assets/arrow-right-icon.png', width='20')
</template>

<script>
import { fromEvent } from 'rxjs'
import { map, switchMap, take } from 'rxjs/operators'

export default {
  name: 'Topics',
  data() {
    return {
      years: [null, null, null, null, null, '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', null, null, null, null, null],
      pointer: 5,
      dragOffset: 0,
      windowWidth: 0,
    }
  },
  methods: {
    moveRight() {
      if(this.pointer >= 5 && this.pointer < 15) { this.pointer++ }
    },
    moveLeft() {
      if(this.pointer > 5 && this.pointer <= 15) { this.pointer-- }
    },
    selectYear(year, index) {
      if(year) { this.pointer = index }
    },
  },
  computed: {
    timelineOffset() {
      const offset = 80 * (this.pointer - 5) + 20
      return { transform: `translateX(${-offset}px)` }
    },
    topicOffset() {
      let topicWidth = this.$store.state.mobile ? this.windowWidth - 40 : 840
      const offset = topicWidth * (this.pointer - 5)
      return { transform: `translateX(${-offset}px)` }
    },
  },
  mounted() {
    const start$ = fromEvent($('.topics ol', this.$el)[0], 'touchstart').pipe(
      map(touchEvent => touchEvent.changedTouches[0].clientX)
    )
    const end$ = fromEvent($('.topics ol', this.$el)[0], 'touchend').pipe(
      map(touchEvent => touchEvent.changedTouches[0].clientX)
    )

    start$.pipe(
      switchMap(start => end$.pipe(
        map(end => -(end - start))
      ))
    ).subscribe(offset => {
      if(offset > 30) { this.moveRight() }
      else if(offset < -30) { this.moveLeft() }
    })

    // force to re-compute topicOffset
    $(window).resize(() => {
      this.windowWidth = $(window).width()
    }).resize()
  },
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-topics
  padding-top: 60px
  position: relative
  &::before, &::after
    +size(70px, 600px)
    content: ''
    display: block
    pointer-events: none
    z-index: 1
  &::before
    +position(absolute, 100px, null, null, calc(50% - 420px))
    background: linear-gradient(-90deg, rgba(black, 0) 0%, rgba(black, 1) 100%)
  &::after
    +position(absolute, 100px, calc(50% - 420px))
    background: linear-gradient(90deg, rgba(black, 0) 0%, rgba(black, 1) 100%)
h2
  +font(42px, #DFFF00, null, 1.05px, 800, center)
  font-family: 'Montserrat Alternates'
  margin-bottom: 40px
.timeline
  +size(840px, 100px)
  display: flex
  list-style-type: none
  margin-left: auto
  margin-right: auto
  overflow: hidden
  position: relative
  user-select: none
  &::before
    +border(1px, white)
    +position(absolute, 18px, 0, null, 0)
    content: ''
    display: block
    height: 4px
  li
    cursor: pointer
    flex: none
    position: relative
    text-align: center
    width: 80px
    transition: transform .2s
    &::before
      +size(2px, 40px)
      background-color: white
      content: ''
      display: block
      margin: 0 auto 10px
      transition: background-color .2s
    &::after
      +position(absolute, 21px, null, null, 80px)
      +size(1px, 20px)
      background-color: white
      content: ''
      display: block
    &.disabled
      pointer-events: none
    label
      +font(14px, white, 1, .34px, 800)
      display: block
      font-family: 'Montserrat Alternates'
      pointer-events: none
      transition: color .2s, transform .2s
    &:hover
      &::before
        background-color: #DFFF00
      label
        color: #DFFF00
        transform-origin: center top
    &.active
      &::before
        background-color: #DFFF00
      label
        +font(null, #DFFF00, null, .64px)
        transform-origin: center top
        transform: scale(2)
.topics
  +flex(space-between, center)
  button
    flex: none
    padding: 10px
  ol
    display: flex
    flex: none
    list-style-type: none
    overflow: hidden
    width: 840px
    > li
      +flex(center, null, column)
      flex: none
      padding-left: 60px
      padding-right: 60px
      transition: transform .2s
      width: 100%
      ul
        padding-left: 10px
        li
          color: #DFFF00
          list-style: disc outside
          margin-bottom: 10px
          span
            +font(16px, #F7F7F7, 24px, .5px)

@media (max-width: 1023px)
  @keyframes arrow
    0%
      opacity: 0
    50%
      opacity: 1
    100%
      opacity: 0

  #v-topics
    padding-top: 30px
    overflow: hidden
    &::before, &::after
      +size(50px, 500px)
    &::before
      +position(null, 90px, null, null, 0)
      background: linear-gradient(-90deg, rgba(black, 0) 0%, rgba(black, 1) 100%)
    &::after
      +position(null, 90px, 0)
      background: linear-gradient(90deg, rgba(black, 0) 0%, rgba(black, 1) 100%)
  h2
    +font(24px, null, null, .6px)
  .timeline
    height: 70px
    left: 50%
    margin-left: 0
    margin-right: 0
    transform: translateX(-50%)
    &::before
      top: 13px
    li
      &::before
        height: 30px
      &::after
        top: 17px
        height: 10px
      label
        +font(12px, null, null, .29px)
      &.active
        label
          transform: scale(1.5)
  .tip
    +font(14px, #DFDFDF, null, .68px, 600, center)
    display: block
    font-family: 'Montserrat Alternates'
    margin-bottom: 15px
    margin-top: 5px
    padding: 5px 10px
    position: relative
    &::before, &::after
      +border(4px 0 4px 8px, transparent transparent transparent #DFFF00)
      content: ''
      display: block
    &::before
      +position(absolute, 10px, calc(50% - 35px))
      animation: arrow 1s infinite
    &::after
      +position(absolute, 10px, calc(50% - 45px))
      animation: arrow 1s .2s infinite
  .topics
    ol
      width: 100%
      > li
        justify-content: flex-start
        padding-left: 20px
        padding-right: 20px
        ul
          padding-left: 20px
          li
            span
              +font(14px, null, 18px, null, null, justify)
</style>
